import React from 'react';
import { Card, Table, TableBody, TableCell, TableRow, withTheme } from '@material-ui/core';
import { connect } from 'react-redux';
import { AscendState } from '../../ducks';
import {
  getSortedMxTransactions,
  getTransactionsByCategory
} from '../../ducks/mx';
import { formatFieldValue } from '../shared/format';
import { MxTransaction } from '../../models/mx';

import { dummyTransactions } from '../dummyData/dummyTransactions';

type StateProps = {
  transactions: MxTransaction[];
  transactionsByCategory: { [category: string]: MxTransaction[] };
};

const getColor = (value: number) => {
  if (value < 0) return 'red';
  if (value > 0) return 'green';
  return 'black';
};

const CategoriesTable = ({transactionsByCategory}: StateProps) => {
  return (
    <Card elevation={2}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2} style={{ fontWeight: 600 }}>
              Categories
            </TableCell>
          </TableRow>
          {
            Object.entries(transactionsByCategory).map(([category, transactions]) => {
              const totalAmount = transactions.reduce((sum, transaction) => {
                if (transaction.type === 'DEBIT') return sum - transaction.amount;
                else return sum + transaction.amount;
              }, 0);

              return(
                <TableRow key={category}>
                  <TableCell>{category}</TableCell>
                  <TableCell style={{ color: getColor(totalAmount), textAlign: 'right' }}>
                    {formatFieldValue(totalAmount, 'number', 'dollar')}
                  </TableCell>
                </TableRow>
              );
            })
          }
        </TableBody>
      </Table>
    </Card>
  );
};

//todo I think I can use mx.ts file to do the following differently will come back to this later as I need to move on to the next pieces and this works
const mapStateToProps = (state: AscendState) => {
  const showDummyData = state.user.data.showDummyData;
  let transactions;
  let transactionsByCategory;
  if (showDummyData) {
    transactions = dummyTransactions;
    // Compute categories manually from dummyTransactions
    transactionsByCategory = dummyTransactions.reduce((acc: { [category: string]: MxTransaction[] }, transaction) => {
      const category = transaction.top_level_category;
      if (!acc[category]) acc[category] = [];
      acc[category].push(transaction);
      return acc;
    }, {});
  } else {
    transactions = getSortedMxTransactions(state);
    transactionsByCategory = getTransactionsByCategory(state);
  }
  return { transactions, transactionsByCategory };
};

export default withTheme()(connect<StateProps>(mapStateToProps)(CategoriesTable));